import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/login/page";
import Signup from "../pages/auth/signup/page";
import Dashboard from "../pages/dashboard/page";
import Calendar from "../pages/calendar/page";
import Clients from "../pages/clients/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/clients",
    element: <Clients />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
